<script lang="ts" setup>
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const { slice } = toRefs(props)
</script>

<template>
  <StrapiSlice
    class="ct-products-feed"
    :slice="slice"
    :index="index"
  >
    <ProductSlider
      v-if="slice?.FeedDisplay?.Display === 'Slider'"
      :products="slice.Products.map(data => data.product)"
      :lazy="index > 0"
    />

    <ul
      v-else-if="slice?.FeedDisplay?.Display === 'Grid'"
      class="ct-products-feed__grid"
    >
      <li
        v-for="(data, i) in slice.Products"
        :key="data"
        class="ct-products-feed__grid-item"
      >
        <ProductTile
          :product="data.product"
          :lazy="index > 0 || i > 2"
        />
      </li>
    </ul>
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/ProductsFeed.css");
</style>
